export default __webpack_public_path__ + "static/transportation-aafeafeacd8f820c224cb1ac9ccbef98.jpg";